import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.css']
})
export class EmailVerificationComponent {
  otpForm: FormGroup;
  passwordForm: FormGroup;
  isEmailVerified = false;
  showPassword = false;
  showConfirmPassword = false;
  constructor(private fb: FormBuilder, private readonly userAuthService: UserService, private router: Router,
    private toastrMsgService: ToastrService) {
    this.otpForm = this.fb.group({
      otp: this.fb.array(
        new Array(6).fill(null).map(() => this.fb.control('', [Validators.required, Validators.pattern(/[0-9]/)]))
      )
    });
    this.initForm();
  }

  getOtpControl(index: number): FormControl {
    return (this.otpForm.get('otp') as FormArray).at(index) as FormControl;
  }

  onOtpInput(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    if (value.length === 1 && index < 5) {
      const next = input.parentElement.querySelectorAll('input')[index + 1];
      if (next) next.focus();
    }
  }

  get otpControls() {
    return (this.otpForm.get('otp') as FormArray).controls;
  }

  submitOtp() {
    const otp = this.otpControls.map(ctrl => ctrl.value).join('');
    console.log('Entered OTP:', otp, this.otpForm.invalid);

    let email = localStorage.getItem("email");
 
    // if (this.otpForm.invalid) {
    //   this.otpForm.markAllAsTouched();
    //   return;
    // }

    this.userAuthService.verifyEmail({ otp: otp, email: email }).subscribe({
      next: (res) => {
this.isEmailVerified = true;
localStorage.setItem("organization", JSON.stringify(res?.data))
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
        // this.authForm.setErrors({ incorrectCredentials: true }); // Set custom error for incorrect credentials
      },
      complete: () => console.log('Observable complete'),
    });
  }


  initForm() {
    this.passwordForm = this.fb.group({
      
         password: [
      '',
      [
        Validators.required,
        Validators.pattern(
          /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
        ),
        Validators.minLength(8),
      ],
    ],
      confirm_password: ['', Validators.required],
    }, { validator: this.passwordMatchValidator });
  }
  passwordMatchValidator(formGroup: AbstractControl): ValidationErrors | null {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirm_password')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }


  submitPassword() {
    if (this.passwordForm.invalid) {
      this.passwordForm.markAllAsTouched();
      return;
    }

    const email = localStorage.getItem('email');
    this.userAuthService.setOrganizationPassword({ password: this.passwordForm.value.password, email: email, id: 2 }).subscribe({
      next: (res) => {
        this.isEmailVerified = true;
        localStorage.clear();
        this.toastrMsgService.success(res?.status);
        const returnUrl = sessionStorage.getItem('bidding_returnUrl');
        if (returnUrl) {
          sessionStorage.removeItem('bidding_returnUrl');
          this.router.navigate(['/login'], { queryParams: { returnUrl } });
        } else {
          this.router.navigate(['login']);
        }
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
        // this.authForm.setErrors({ incorrectCredentials: true }); // Set custom error for incorrect credentials
      },
      complete: () => console.log('Observable complete'),
    });
  }

  resendOtp() {
    let email = localStorage.getItem("email");
    this.userAuthService.resendOtp({ email: email }).subscribe({
      next: (res) => {
this.isEmailVerified = true;
localStorage.setItem("organization", JSON.stringify(res?.data))

this.toastrMsgService.error(res?.status?.message);
this.router.navigate(["home/dashboard"]);
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
        // this.authForm.setErrors({ incorrectCredentials: true }); // Set custom error for incorrect credentials
      },
      complete: () => console.log('Observable complete'),
    });
    
  }
}